import { apiFunction } from "../../apiCalls/functions"
import * as APIs from "../../apiCalls/urls/student"
import { apiLoading, apiLoadingEnd } from "../../store/notification/action";
import { actionNotifier } from "../../components/ui/toast";
import { getDataFromStore } from "../../store/getStore";
import * as EXAM_APIs from "../../apiCalls/urls/exam";


//AllAPIS
export const fetchStudentPerStatus = async (status, start, end, search) => {
    return await apiFunction(APIs.VIEW_STUDENT_PER_STATUS + `${status}/${start}/${end}?search=${search}`, 'get', {}, true, false)
}

export const fetchUserPerId = async (id) => {
    return await apiFunction(APIs.VIEW_USER_PER_ID + `${id}`, 'get', {}, true, false)
}

export const updateUserStatus = async (data) => {
    return await apiFunction(APIs.UPDATE_USER_STATUS, 'post', data, true, false)
}

export const addReschedule = async (data) => {
    return await apiFunction(APIs.ADD_RESCHEDULE, 'post', data, true, false)
}


export const updateUserDetails = async (data) => {
    return await apiFunction(APIs.UPDATE_USER_DETAILS, 'put', data, true, false)
}

export const updateReRegister = async (data) => {
    return await apiFunction(APIs.UPDATE_RE_REGISTER, 'post', data, true, false)
}

export const getService = async () => {
    return await apiFunction(APIs.GET_SERVICE, 'get', {}, true, false)
}

export const getDepartment = async () => {
    return await apiFunction(APIs.GET_DEPARTMENT, 'get', {}, true, false)
}
export const getServiceCadre = async () => {
    return await apiFunction(APIs.GET_SERVICE_CADRE, 'get', {}, true, false)
}
export const getRejectionReasons = async () => {
    return await apiFunction(APIs.GET_REJECTION_REASONS, 'get', {}, true, false)
}
export const getCat = async () => {
    return await apiFunction(APIs.GET_CATEGORY, 'get', {}, true, false)
}

export const getResult = async (id) => {
    return await apiFunction(APIs.GET_RESULT+id, 'get', {}, true, false)
}

// Adds minutes to `time_remaining` for the selected candidates. The server
// verifies every id belongs to a centre this admin administers.
// centre + otp are mandatory server-side: extending time alters a live exam, so
// it needs the same centre-officer authorisation as a forced re-login.
export const extendExamTime = async (uem_ids, minutes, centre, otp) => {
  return await apiFunction(EXAM_APIs.EXTEND_EXAM_TIME, "post", { uem_ids, minutes, centre, otp }, true, false);
};
